import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { EventTimelineItemModel } from '@app/events/shared/event-timeline-item.model';
import { EventTimelineItemService } from '@app/events/shared/event-timeline-item.service';

@Injectable({
  providedIn: 'root',
})
export class EventTimelineItemResolver {
  constructor(private service: EventTimelineItemService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<EventTimelineItemModel> {
    return this.service.getById(route.paramMap.get('timelineItemId') || '').pipe(map((item) => item.data));
  }
}
